// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import { TypographyProps } from "@insite/mobius/Typography";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { boxStyles } from "@store/Themes/common/mixins/box";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export interface CreditSummaryGridProps {
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
    innerWrapper?: InjectableCss;
    price?: TypographyProps;
    label?: TypographyProps;
}

export const creditSummaryGridProps: CreditSummaryGridProps = {
    gridContainer: {
        gap: 0,
        css: css`
            box-shadow: ${getProp("theme.shadows.dark20")};

            ${GridItemStyle}:not(:last-child) {
                ${breakpoint("xs", "only")} {
                    &::after {
                        content: "";
                        position: absolute;
                        left: 50%;
                        right: 0;
                        bottom: 0;
                        transform: translateX(-50%);
                        height: ${pxToRem(1)};
                        width: calc(100% - 40px);
                        background-color: ${getColor("common.border")};
                        pointer-events: none;
                    }
                }

                ${StyledWrapper} {
                    ${breakpoint("sm")} {
                        border-right: ${pxToRem(1)} solid ${getColor("common.border")};
                    }
                }
            }
        `,
    },
    gridItem: {
        width: [12, 4, 4, 4, 4],
        css: css`
            position: relative;
            padding: ${pxToRem(20)};
        `,
    },
    innerWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: ${pxToRem(8)};
            width: 100%;

            ${breakpoint("sm")} {
                flex-direction: column;
                align-items: flex-start;
            }
        `,
    },
    price: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.larger};
            font-weight: ${x => x.theme.design.typography.weight.bold};
            color: ${getColor("primary")};
        `,
    },
    label: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.smaller};
            font-weight: ${x => x.theme.design.typography.weight.extrabold};
        `,
    },
};

export interface CreditSummaryStackProps {
    wrapper?: InjectableCss;
    titleWrapper?: InjectableCss;
    title?: TypographyProps;
    itemWrapper?: InjectableCss;
    itemLabel?: TypographyProps;
    itemValue?: TypographyProps;
}

const itemLabel: TypographyProps = {
    css: css`
        display: table-cell;
    `,
};

const itemValue: TypographyProps = {
    css: css`
        display: table-cell;
        text-align: right;
        padding-left: ${pxToRem(10)};
        white-space: nowrap;
        color: ${getColor("primary")};
        font-weight: ${x => x.theme.design.typography.weight.extrabold};
    `,
};

export const creditSummaryStackProps: CreditSummaryStackProps = {
    wrapper: {
        css: css`
            ${boxStyles(pxToRemArray([20]))}
            display: block;
            width: 100%;
            box-shadow: none;
            border: ${pxToRem(1)} solid ${getColor("common.border")};
        `,
    },
    titleWrapper: {
        css: css`
            min-width: 100%;
            ${spacingStyles(null, pxToRem(8), "padding")}
        `,
    },
    title: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
            text-transform: uppercase;
        `,
    },
    itemWrapper: {
        css: css`
            display: table;
            width: 100%;
            ${spacingStyles(pxToRem(8), pxToRem(8), "padding")}
            font-size: ${x => x.theme.design.typography.size.smaller};
        `,
    },
    itemLabel,
    itemValue,
};
